import { css } from '@emotion/css'
import { spacing, fontFamily, fontSize, borderRadius, shorthandHelper, colors, hexToRgba } from '@offerzen/pinata'

const styles = {
  menu: css({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  wrapper: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    transition: 'opacity 0.2s',
  }),

  overlay: css({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    cursor: 'pointer',
  }),

  nav: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    marginLeft: 'auto',
    height: '100%',
    width: '75%',
    backgroundColor: colors.oxfordBlue,
    borderLeft: `1px solid ${colors.blueZodiac}`,
    overflowY: 'auto',
    transition: 'transform 0.3s',
  }),

  navItem: css({
    position: 'relative',
    borderBottom: `1px solid ${colors.blueZodiac}`,
  }),

  link: css({
    position: 'relative',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    padding: spacing.medium,
    borderRight: '4px solid transparent',
    transition: 'color 0.2s',

    '& svg': {
      fill: hexToRgba(colors.white, 0.6),
    },

    '&:hover': {
      color: colors.white,

      '& svg': {
        fill: colors.white,
      },
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,

      '& svg': {
        fill: colors.white,
      },
    },
  }),

  linkButton: css({
    display: 'flex',
    padding: spacing.large,
    color: colors.cornflowerBlue,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'none',
    },

    '&:hover > span': {
      backgroundColor: colors.blueZodiac,
      boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`,
    },

    '& > span': {
      flex: 1,
      height: 35,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      border: `1px solid ${colors.cornflowerBlue}`,
      borderRadius: borderRadius.extraLarge,
    },
  }),

  subNav: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginTop: -spacing.small,
    position: 'relative',
  }),

  subLink: css({
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: hexToRgba(colors.white, 0.6),
    padding: shorthandHelper([spacing.default, spacing.large * 2]),
    borderRight: '4px solid transparent',
    fontSize: fontSize.small,
    transition: 'color 0.2s',

    '&:hover': {
      color: colors.white,
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,
    },
  }),

  icon: css({
    marginRight: spacing.default,
  }),

  chip: css({
    marginLeft: 'auto',
  }),

  alertIcon: css({
    position: 'absolute',
    top: 14,
    left: 28,

    '& svg': {
      fill: colors.mandy,
    },
  }),
}

export default styles

export const wrapperTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        opacity: 0,
      })

    case 'entered':
      return css({
        opacity: 1,
      })

    case 'exiting':
    case 'exited':
      return css({
        opacity: 0,
      })
  }
}

export const navTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        transform: 'translateX(100%)',
      })

    case 'entered':
      return css({
        transform: 'translateX(0)',
      })

    case 'exiting':
    case 'exited':
      return css({
        transform: 'translateX(100%)',
      })
  }
}
